import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  IntercompanyBranchService,
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, mergeMap, distinctUntilChanged, map } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';
@Component({
  selector: 'select-intercompany-branch-drop-down',
  templateUrl: './select-intercompany-branch-drop-down.component.html',
  styleUrls: ['./select-intercompany-branch-drop-down.component.css']
})
export class SelectIntercompanyBranchDownComponent implements OnInit, OnDestroy {

  @Input() intercompanyBranchControl: FormControl;
  @Input() entityGuid; // guid of entity selected in the account tab
  @Input() label: any;

  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();
  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  entityList: any[];
  fieldLabel: string;

  constructor( 
    private intercompanyBranchService: IntercompanyBranchService,
    ) {}

  ngOnInit() {
    this.fieldLabel = this.label;

    if ((this.entityGuid !== undefined) && (this.entityGuid !== null) ) {

      console.log("entityGuid", this.entityGuid)

      let payload = {
        guid:this.entityGuid
      }
      this.subs.sink = this.intercompanyBranchService.getByEntity(payload, this.apiVisa).subscribe(
        {next: resolve => {
          this.entityList = resolve.data;
          this.filteredOptions$.next(this.entityList);
          console.log("list", resolve.data)
        }});
  
      this.subs.sink = this.filterControl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe({next: resolve => this.filterWarehouse(resolve)});
    }


  }


  filterWarehouse(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.entityList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.entityList.filter(c => c.bl_fi_mst_entity_branch_hdr.name.toLocaleLowerCase().includes(search) || c.bl_fi_mst_entity_branch_hdr.code.toLocaleLowerCase().includes(search)  );
      this.filteredOptions$.next(filter);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

